import Service from "../../../api/api-service";
import { ApiUrl } from "../../../api/api-url";

const service = new Service();

export const Contact = (data) => {
    return service.post(ApiUrl.ContactToAdmin, data).then((res) => {return res}).catch((err) => { throw err });
}